<ng-container >
  @if (cartData?.totalItems > 0) {
    <div class="cart-summary" [ngClass]="{ 'summary-loading': knBrCommonService.isCartLoading() }">
      @if (!isCheckoutPage()) {
        <h2 class="summary-title">Order Summary</h2>
      }
      @if (isCheckoutPage()) {
        <h2 class="summary-title checkout">Your Order</h2>
      }
      <div class="summary-row">
        <span>Subtotal ({{ cartData.totalItems }} {{ cartData.totalItems === 1 ? 'item' : 'items' }})</span>
        @if (!knBrCommonService.isCartLoading()) {
          <span>{{ cartData.subTotal?.formattedValue }}</span>
        }
        @if (knBrCommonService.isCartLoading()) {
          <span class="loading-text">
            Calculating...
            <div class="loading-spinner"></div>
          </span>
        }
      </div>
      @if (!isCheckoutPage()) {
        <div class="summary-row shipping">
          <span>Shipping</span>
          @if (!knBrCommonService.isCartLoading()) {
            <span>{{ cartData.deliveryCost?.formattedValue }}</span>
          }
          @if (knBrCommonService.isCartLoading()) {
            <span class="loading-text">
              Calculating...
              <div class="loading-spinner"></div>
            </span>
          }
        </div>
      }
      @if (isCheckoutPage()) {
        <div class="summary-row shipping">
          <span>{{ cartData.deliveryMode?.code === 'delivery' ? 'Shipping' : cartData.deliveryMode?.name }}</span>
          @if (!knBrCommonService.isCartLoading()) {
            <span>{{ cartData.deliveryMode?.code === 'pickUp' ? 'FREE' : cartData.deliveryCost?.formattedValue }}</span>
          }
          @if (knBrCommonService.isCartLoading()) {
            <span class="loading-text">
              Calculating...
              <div class="loading-spinner"></div>
            </span>
          }
        </div>
      }
      <div class="summary-row">
        <span>Estimated Sales Tax*</span>
        @if (!knBrCommonService.isCartLoading()) {
          <span>{{ cartData.totalTax?.formattedValue }}</span>
        }
        @if (knBrCommonService.isCartLoading()) {
          <span class="loading-text">
            Calculating...
            <div class="loading-spinner"></div>
          </span>
        }
      </div>
      <div class="summary-row total">
        <span>Total</span>
        @if (!knBrCommonService.isCartLoading()) {
          <span>{{ cartData.totalPriceWithTax?.formattedValue }}</span>
        }
        @if (knBrCommonService.isCartLoading()) {
          <span class="loading-text">
            Calculating...
            <div class="loading-spinner"></div>
          </span>
        }
      </div>
      <div class="po-job-section">
        <label for="po-job-number" class="po-job-label">
          PO/Job Number <span class="optional">(optional)</span>
        </label>
        <input
          type="text"
          id="po-job-number"
          class="po-job-input"
          [ngClass]="{ 'po-input-disable': disablePoNumber }"
          [placeholder]="disablePoNumber ? '' : 'Enter PO Or Job Number'"
          [disabled]="disablePoNumber"
          [(ngModel)]="poJobNumber"
          />
        </div>
        @if (!isCheckoutPage()) {
          <button (click)="navigateToCheckOutUrl(cartData?.deliveryMode?.code, poJobNumber)" class="btn btn-primary" [disabled]="knBrCommonService.isCartLoading()">
            Proceed to Checkout
          </button>
          <a (click)="navigate('/search/active-brands')" class="continue-shopping">Continue Shopping</a>
        }
        @if (isCheckoutPage()) {
          <button (click)="placeOrderClick()" class="btn btn-primary" [disabled]="knBrCommonService.isCartLoading() || placeOrderButtonDisabled">
            Place Order
          </button>
          <div class="order-confirmation-note">
            The order confirmation and updates will be emailed to
            <strong>{{ userEmail }}</strong>
          </div>
        }
      </div>
    }
  </ng-container>